<template>
    <el-dialog
        :closeOnClickModal="false"
        class="sign-confirm-dialog receiptSignSignInDialog"
        :title="titleName[type]"
        :visible="true"
        :before-close="closeDialogOnly"
        width="80%"
    >
        <div class="signContent" v-loading="loading">
            <div class="receiveLeft">
                <div class="viewerBox" v-show="imgArr.length">
                    <ul id="viewers">
                        <li v-for="(item, index) in imgArr" :key="index">
                            <img :src="item.url" />
                        </li>
                    </ul>
                </div>
                <div class="emptyImgBox" v-show="!imgArr.length">
                    <i class="el-icon-picture"></i>
                </div>
                <div class="uploader" v-if="!['7','9'].includes(type)">
                    <upload-new-btn
                        ref="signUpload"
                        type="btn"
                        multiple
                        businessKey="default"
                        bucket="c-tms"
                        contentType="application/octet-stream"
                        :needBtn="false"
                        :limit="3"
                        :publicRead="1"
                        :compressImage="true"
                        :compressQuality="0.5"
                        @beforeUpload="beforeUpload"
                        @callback="uploadResponse"
                    >
                        <i class="el-icon-plus pictures"></i>
                    </upload-new-btn>
                    <el-popover
                            placement="bottom"
                            width="160"
                            v-show="imgArr.length > 1"
                            v-model="confirmVisible"
                            trigger="click">
                        <p> <i class="el-icon-info" style="color:red"></i> 确定删除当前图片？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button type="text" size="mini" @click="confirmVisible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="deleteBtn">确定</el-button>
                        </div>
                        <i class="el-icon-delete smallBtn" slot="reference"></i>
                    </el-popover>
                    <i class="el-icon-download smallBtn" @click="downloadBtn" v-show="imgArr.length"></i>
                </div>
            </div>
            <div class="receiveRight">
                <el-form :inline="true" :model="totalForm" :rules="rules" ref="formInfo">
                    <el-row>
                        <el-col :span="8" class="mainInfos">
                            <el-form-item><span>客户订单号： {{totalForm.customerOrderNo}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="mainInfos">
                            <el-form-item><span>订单号： {{totalForm.orderNo}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="mainInfos">
                            <el-form-item
                                v-if="['1','5','6','7','8','9','10'].includes(type)"
                            ><span>运单号： {{totalForm.waybillNo}}</span>
                            </el-form-item>
                            <el-form-item
                                v-else-if="type === '2'"
                            >汇总： 实发 {{totalForm.finalNetReceiveCount}} / 实收 {{finalReceiveCount}} / 异常 {{finalAbnormalCount}}</el-form-item>
                            <el-form-item
                                v-else-if="type === '3'"
                            >入库时间： {{totalForm.netInTime}}</el-form-item>
                            <el-form-item
                                v-else-if="type === '4'"
                            >出库时间： {{totalForm.netOutTime}}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item
                                v-if="type === '1' || type === '10'"
                                label="汇总："
                            >实收 {{netReceiveCount}} / 异常 {{netAbnormalCount}}</el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item v-if="type === '1'" label="签收人：">
                                <el-input
                                    v-model="totalForm.networkReceiptName"
                                    class="receipt-name"
                                    clearable
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item v-if="type === '10'" label="拒收人：" prop="refuseName">
                                <el-input
                                    v-model="totalForm.refuseName"
                                    class="receipt-name"
                                    clearable
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                v-if="['2'].includes(type)"
                                label="增值服务类型："
                                prop="addedServiceType"
                                class="addedServiceType"
                            >
                                <otp-select
                                    v-model="totalForm.addedServiceType"
                                    :optionNum="'ADDED_SERVICE'"
                                    prop="addedServiceType"
                                    @getSelectValue="getSelectValue"
                                ></otp-select>
                            </el-form-item>
                            <el-form-item
                                v-if="['5'].includes(type)&&+rowData.serviceType===1&&rowData.businessMode === 'B2C'"
                                label="增值服务类型："
                                prop="addedServiceType"
                                class="addedServiceType"
                            >
                                <otp-select
                                    v-model="totalForm.addedServiceType"
                                    :optionNum="'ADDED_SERVICE_B2C'"
                                    prop="addedServiceType"
                                    @getSelectValue="getSelectValue"
                                ></otp-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                                <el-form-item
                                    v-if="['6'].includes(type)"
                                    label="一级原因："
                                    prop="exceptionReason1Code"
                                    class="refuseReason"
                                >
                                    <otp-select
                                        :optionNum="'NET_REFUSE_REASON_1'"
                                        v-model="totalForm.exceptionReason1Code"
                                        :filterable="true"
                                        @input="getRefuseReason1"
                                        @getSelectLabel="value=>{totalForm.exceptionReason1Name=value}"
                                    ></otp-select>
                                </el-form-item>
                                <el-form-item
                                    v-if="['8'].includes(type)"
                                    label="取件失败原因："
                                    class="pickupFailReason"
                                >
                                    <otp-select
                                        :optionNum="'NET_PICKUP_ERROR'"
                                        v-model="totalForm.exceptionReason2Code"
                                        :filterable="true"
                                        @input="getRefuseReason2"
                                        @getSelectLabel="value=>{totalForm.exceptionReason2Name=value}"
                                    ></otp-select>
                                </el-form-item>
                            <el-form-item
                                label="一级原因："
                                v-if="['7','9'].includes(type)"
                            >{{totalForm.exceptionReason1Name}}</el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item
                                v-if="['6'].includes(type)"
                                label="二级原因："
                                prop="exceptionReason2Code"
                                class="refuseReason"
                            >
                                <el-select
                                    v-model="totalForm.exceptionReason2Code"
                                    @change="getRefuseReason2"
                                    placeholder="请先选择一级原因"
                                    filterable
                                >
                                    <el-option
                                      v-for="item in currentReason2List"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="二级原因："
                                v-if="['7','9'].includes(type)"
                            >{{totalForm.exceptionReason2Name}}</el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item
                        v-if="['5','6','8'].includes(type)"
                        label="备注："
                        class="rejectRemark"
                        prop="remark"
                    >
                        <el-input v-model="totalForm.remark" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" v-if="['7','9'].includes(type)">{{totalForm.remark}}</el-form-item>
                    <el-form-item v-else-if="type === '3'" label="网点入库备注：" class="inoutRemark">
                        <el-input v-model="totalForm.netInRemark" clearable></el-input>
                    </el-form-item>
                    <el-form-item v-else-if="type === '4'" label="网点出库备注：" class="inoutRemark">
                        <el-input v-model="totalForm.netOutRemark" clearable></el-input>
                    </el-form-item>
                </el-form>
                <!-- 商品列表 -->
                <el-table :data="tableData" border tooltip-effect="dark" height="260">
                    <el-table-column
                        v-if="['1','2','3','4','10'].includes(type)"
                        show-overflow-tooltip
                        prop="itemCode"
                        label="商品编码"
                        width="140"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        v-if="['5','6','7','8','9'].includes(type)"
                        show-overflow-tooltip
                        prop="customerItemCode"
                        label="商品编码"
                        width="140"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        show-overflow-tooltip
                        prop="itemName"
                        label="商品名称"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        v-if="['6','7','8','9'].includes(type)"
                        prop="netRealReceive"
                        label="正品"
                        width="120"
                        align="center"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="['1','2','5','10'].includes(type)"
                        show-overflow-tooltip
                        label="正品"
                        width="100"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div style="position: relative;">
                                <div style="position: absolute; height: 100%; width: 100%"></div>
                                <template v-if="['1','5','10'].includes(type)">
                                    <el-tooltip
                                        :tabindex="-1"
                                        v-model="scope.row.netRealReceive.showToptip"
                                        effect="dark"
                                        content="正品不能为负数 请仔细核对"
                                        placement="bottom"
                                    >
                                        <!-- 下边的margin是为了解决。。两个完全重合的div，会触发下边元素的mouseenter，可能重合有误差，渲染问题 -->
                                        <div
                                            :class="{red: scope.row.netRealReceive.showToptip}"
                                            style="margin: 0 5px"
                                        >{{netRealReceive(scope.$index)}}</div>
                                    </el-tooltip>
                                </template>
                                <template v-else-if="type === '2'">
                                    <el-tooltip
                                        :tabindex="-1"
                                        v-model="scope.row.finalRealReceive.showToptip"
                                        effect="dark"
                                        content="正品不能为负数 请仔细核对"
                                        placement="bottom"
                                    >
                                        <div
                                            :class="{red: scope.row.finalRealReceive.showToptip}"
                                            style="margin: 0 5px"
                                        >{{finalRealReceive(scope.$index)}}</div>
                                    </el-tooltip>
                                </template>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="type === '2' && rowData.projectClassify !=='WP'"
                        show-overflow-tooltip
                        label="污染"
                        width="100"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div>
                                <el-input-number
                                    @change="resetToptip"
                                    v-if="scope.row.finalMildewPollute.show"
                                    v-model="scope.row.finalMildewPollute.value"
                                    size="mini"
                                    controls-position="right"
                                    :min="0"
                                    :precision="0"
                                ></el-input-number>
                                <div
                                    v-else
                                    @click="edit(scope.row.finalMildewPollute, 'finalMildewPollute')"
                                >{{scope.row.finalMildewPollute.value}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="type === '2' && rowData.projectClassify !=='WP'"
                        show-overflow-tooltip
                        label="破损"
                        width="100"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div>
                                <el-input-number
                                    @change="resetToptip"
                                    v-if="scope.row.finalPackageDamaged.show"
                                    v-model="scope.row.finalPackageDamaged.value"
                                    size="mini"
                                    controls-position="right"
                                    :min="0"
                                    :precision="0"
                                ></el-input-number>
                                <div
                                    v-else
                                    @click="edit(scope.row.finalPackageDamaged, 'finalPackageDamaged')"
                                >{{scope.row.finalPackageDamaged.value}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="['1','2','5'].includes(type)"
                        show-overflow-tooltip
                        label="短少"
                        width="100"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div
                                v-if="['1','5'].includes(type)"
                            >{{scope.row.netStockoutCount.value}}</div>
                            <div v-else-if="type === '2'">
                                <el-input-number
                                    @change="resetToptip"
                                    v-if="scope.row.finalStockoutCount.show"
                                    v-model="scope.row.finalStockoutCount.value"
                                    size="mini"
                                    controls-position="right"
                                    :min="0"
                                    :precision="0"
                                ></el-input-number>
                                <div
                                    v-else
                                    @click="edit(scope.row.finalStockoutCount, 'finalStockoutCount')"
                                >{{scope.row.finalStockoutCount.value}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="['2','5','10'].includes(type)"
                        show-overflow-tooltip
                        label="拒收"
                        width="100"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div v-if="type === '5'">{{scope.row.netStockoutCount.value}}</div>
                            <div v-if="type === '10'">{{scope.row.netRejectQty.value}}</div>
                            <div v-if="type === '2'">
                                <el-input-number
                                    @change="resetToptip"
                                    v-if="scope.row.finalRejectQty.show"
                                    v-model="scope.row.finalRejectQty.value"
                                    size="mini"
                                    controls-position="right"
                                    :min="0"
                                    :precision="0"
                                ></el-input-number>
                                <div
                                    v-else
                                    @click="edit(scope.row.finalRejectQty, 'finalRejectQty')"
                                >{{scope.row.finalRejectQty.value}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="type === '1' || type === '2' || type === '10'"
                        show-overflow-tooltip
                        label="备注"
                        width="150"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div>
                                <el-input
                                    v-if="type === '1'"
                                    v-model.trim="scope.row.networkSignRemark"
                                    class="remark"
                                    clearable
                                ></el-input>
                                <el-input
                                    v-else-if="type === '2'"
                                    v-model.trim="scope.row.finalSignRemark"
                                    class="remark"
                                    clearable
                                ></el-input>
                                <el-input
                                    v-else-if="type === '10'"
                                    v-model.trim="scope.row.branchRejectRemark"
                                    class="remark"
                                    clearable
                                ></el-input>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="type === '3'"
                        prop="planQty"
                        show-overflow-tooltip
                        label="网点计划入库数量"
                        width="150"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        v-if="type === '4'"
                        prop="netStorageCount"
                        show-overflow-tooltip
                        label="网点出库数量"
                        width="150"
                        align="center"
                    ></el-table-column>
                </el-table>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <div v-show="showAppointWarning" class="showAppointWarning">当前为非预约时间当天，请核实后签收！</div>
            <el-button @click="closeDialogOnly">取 消</el-button>
            <el-button type="primary" @click="handleNetConfirm" v-if="type === '1'">确 认</el-button>
            <el-button type="primary" @click="handleFinalConfirm" v-else-if="type === '2'">确 认</el-button>
            <el-button type="primary" @click="handleInboundConfirm" v-else-if="type === '3'">确 认</el-button>
            <el-button type="primary" @click="handleOutboundConfirm" v-else-if="type === '4'">确 认</el-button>
            <el-button type="primary" @click="branchRejectConfirm" v-else-if="type === '10'">确 认</el-button>
            <el-button
                type="primary"
                @click="handleClientSignConfirm2C"
                v-else-if="type === '5'"
            >确 认</el-button>
            <el-button
                type="primary"
                @click="handleClientRejectConfirm"
                v-else-if="type === '6'"
            >确 认</el-button>
            <el-button type="primary" @click="handleReject" v-else-if="['7','9'].includes(type)">驳 回</el-button>
            <el-button type="primary" @click="handleApprove" v-if="['7','9'].includes(type)">通 过</el-button>
            <el-button type="primary pick-btn" @click="hadlePickupSuccess" v-else-if="type === '8'">取件成功</el-button>
            <el-button type="danger pick-btn" @click="hadlePickupFail" v-if="type === '8'">取件失败</el-button>
        </div>
    </el-dialog>
</template>
<script>
import dayjs from 'dayjs';
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import OtpSelect from '@/components/lots/otpSelect2';
import { mapState } from 'vuex';
import _ from '@/components/lots/utils';
import api from '../../../../../api/netTaskManage2c';
import data from './data';
import refuseOption from '../refuseOption';
import UploadNewBtn from '@/components/lots/OSS/UploadNewBtn';

export default {
    components: { UploadNewBtn, OtpSelect },
    props: {
        rowData: {
            type: Object,
            default() {
                return {};
            }
        },
        onBeforeUpload: {
            type: Function
        },
        type: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            REFUSE_REASON_2: refuseOption.REFUSE_REASON_2,
            loading: false,
            confirmVisible: false,
            titleName: {
                1: '网点签收',
                2: '用户签收',
                3: '网点入库',
                4: '网点出库',
                5: '用户签收',
                6: '用户拒签',
                7: '用户拒签审核',
                8: '上门取件',
                9: '取件失败审核',
                10: '网点拒收'
            },
            viewer: {},
            updateTime: '',
            updateUserName: '',
            currentDate: dayjs().format('YYYY-MM-DD'),
            showAppointWarning: false,
            totalForm: {
                customerOrderNo: '',
                orderNo: '',
                waybillNo: '',
                networkReceiptName: '',
                networkSignTime: '',
                finalNetReceiveCount: 0,
                finalSignTime: '',
                finalReceiptName: '',
                addedServiceType: '',
                netInTime: '',
                netInRemark: '',
                netOutTime: '',
                netOutRemark: '',
                exceptionReason1Code: '',
                exceptionReason1Name: '',
                exceptionReason2Code: '',
                exceptionReason2Name: '',
                remark: '',
                refuseName: ''
            },
            rules: {
                addedServiceType: [
                    {
                        required: true,
                        message: '请选择增值服务类型',
                        trigger: 'change'
                    }
                ],
                networkReceiptName: [
                    {
                        required: true,
                        message: '请输入签收人',
                        trigger: 'blur'
                    }
                ],
                exceptionReason1Code: [
                    {
                        required: true,
                        message: '请选择一级原因',
                        trigger: 'change'
                    }
                ],
                exceptionReason2Code: [
                    { required: true, message: '请选择二级原因', trigger: 'change' }
                ],
                finalReceiptName: [
                    {
                        required: true,
                        message: '请输入签收人',
                        trigger: 'blur'
                    }
                ],
                receivedCode: [
                    {
                        required: true,
                        message: '请输入签收码',
                        trigger: 'blur'
                    }
                ],
                refuseName: [
                    {
                        required: true,
                        message: '请输入拒收人',
                        trigger: 'blur'
                    }
                ]
            },
            currentReason2List: [],
            tableData: [],
            imgArr: [],
            carouselIndex: 0, // 轮播图当前的索引
            formConfig: []
        };
    },
    mounted() {
        this[data.typeAction[this.type]]();
    },
    methods: {
        resetToptip() {
            this.tableData.find((item) => {
                if (
                    this.type === '1' &&
                    item.netRealReceive.showToptip === true
                ) {
                    item.netRealReceive.showToptip = false;
                    return true;
                } else if (
                    this.type === '5' &&
                    item.finalRealReceive.showToptip === true
                ) {
                    item.finalRealReceive.showToptip = false;
                    return true;
                }
            });
        },
        // 检验是否预约时间外
        countAppointStatus() {
            if (this.currentDate !== dayjs(this.rowData.networkAppointmentStart).format('YYYY-MM-DD')) {
                this.showAppointWarning = true;
            }
        },
        getSelectValue(data) {
            this.totalForm.addedServiceType = data.addedServiceType;
        },
        beforeUpload(file) {
            this.loading = true;
            return this.onBeforeUpload(file);
        },
        downloadBtn() {
            window.location =
                this.imgArr[this.carouselIndex].url;
        },
        async deleteBtn() {
            const imageId = this.imgArr[this.carouselIndex].id;
            this.loading = true;
            await api
                .delImages(imageId)
                .then((res) => {
                    if (res && res.code === '0') {
                        this.imgArr.splice(this.carouselIndex, 1);
                        this.$message.success('删除成功');
                        this.updateViewer();
                    }
                })
                .catch(() => {});
            this.confirmVisible = false;
            this.loading = false;
        },
        async uploadResponse(response) {
            this.loading = false;
            this.$emit('branchSignUploadResponse', response);
        },
        updateViewer() {
            this.carouselIndex = 0;
            this.viewer.destroy();
            setTimeout(() => {
                this.initViewer();
            });
        },
        edit(obj, property) {
            obj.show = true;
        },
        initViewer() {
            this.loading = true;
            const barOptions = { show: true, size: 'small' };
            this.viewer = new Viewer(document.getElementById('viewers'), {
                inline: true,
                title: false,
                navbar: true,
                button: true,
                view: (info) => {
                    this.carouselIndex = info.detail.index;
                },
                toolbar: {
                    zoomIn: barOptions,
                    zoomOut: barOptions,
                    prev: barOptions,
                    reset: barOptions,
                    next: barOptions,
                    rotateLeft: barOptions,
                    rotateRight: barOptions
                }
            });
            this.$refs.formInfo.clearValidate();
            this.loading = false;
        },
        getListParams() {
            this.loading = true;
            this.imgArr = [];
            Object.keys(this.totalForm).forEach((key) => {
                this.totalForm[key] = '';
            });
            const params = {
                orderNo: this.rowData.orderNo
            };
            if (this.type === '7') {
                params.type = '6';
            } else if (this.type === '9') {
                params.type = '8';
            } else {
                params.type = this.type;
            }
            return params;
        },
        updateImgList() {
            if (this.viewer.images) this.viewer.destroy();
            this.getUpdateImgList();
        },
        handleImgList(imgs) {
            this.imgArr = imgs.reverse() || [];
        },
        async getUpdateImgList() {
            // 图片上传成功只处理刷新图片部分
            this.loading = true;
            this.imgArr = [];
            const params = {
                orderNo: this.rowData.orderNo,
                type: this.type
            };
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res && res.code === '0') {
                        this.handleImgList(res.data.images);
                    }
                })
                .catch(() => {});
            this.$nextTick(() => {
                this.initViewer();
            });
            this.loading = false;
        },
        // 网点签收查询列表
        async netSignList() {
            const params = this.getListParams();
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res) {
                        const data = res.data;
                        this.totalForm = data;
                        const netTaskItemsList = data.netTaskItems || [];
                        netTaskItemsList.forEach((item) => {
                            item.planQty = item.planQty || 0;
                            if (this.type === '10') {
                                item.netRealReceive = {
                                    show: false,
                                    value: 0,
                                    showToptip: false
                                };
                                item.netRejectQty = { show: false, value: item.planQty };
                            } else {
                                item.netRealReceive = {
                                    show: false,
                                    value: item.planQty,
                                    showToptip: false
                                };
                                item.netRejectQty = { show: true, value: 0 };
                            }
                            this.tableData.push({
                                id: item.id,
                                itemCode: item.itemCode,
                                itemName: item.itemName,
                                planQty: item.planQty,
                                netRealReceive: item.netRealReceive,
                                netStockoutCount: { show: true, value: 0 },
                                netRejectQty: item.netRejectQty,
                                networkSignRemark: item.networkSignRemark || '',
                                itemLineNo: item.itemLineNo,
                                version: item.version,
                                orderNo: item.orderNo
                            });
                        });
                        // 获取图片
                        this.handleImgList(res.data.images);
                    }
                })
                .catch(() => {});
            await this.$nextTick(() => {
                this.initViewer();
            });
            this.loading = false;
        },
        // 用户签收查询列表2B (终端签收)
        async finalSignList() {
            const params = this.getListParams();
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res) {
                        const data = res.data;
                        this.totalForm = data;
                        let finalNetReceiveCountNum = 0;
                        const finalList = data.netTaskItems || [];
                        finalList.forEach((item) => {
                            finalNetReceiveCountNum += item.netRealReceive;
                            item.netRealReceive = item.netRealReceive || 0;
                            this.tableData.push({
                                id: item.id,
                                itemCode: item.itemCode,
                                itemName: item.itemName,
                                netRealReceive: item.netRealReceive,
                                finalRealReceive: {
                                    show: false,
                                    value: item.netRealReceive,
                                    showToptip: false
                                },
                                finalStockoutCount: { show: true, value: 0 },
                                finalRejectQty: { show: true, value: 0 },
                                finalPackageDamaged: { show: true, value: 0 },
                                finalMildewPollute: { show: true, value: 0 },
                                itemLineNo: item.itemLineNo,
                                version: item.version,
                                orderNo: item.orderNo
                            });
                        });
                        this.totalForm.finalNetReceiveCount = finalNetReceiveCountNum;
                        this.handleImgList(res.data.images);
                        this.countAppointStatus();
                    }
                })
                .catch(() => {});
            await this.$nextTick(() => {
                this.initViewer();
            });
            this.loading = false;
        },
        // 获取网点入库信息
        async inboundList() {
            const params = this.getListParams();
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res) {
                        const data = res.data;
                        this.totalForm = data;
                        const inboundList = data.netTaskItems || [];
                        inboundList.map((item) => {
                            if (!item.planQty) item.planQty = 0;
                            item.netStorageCount = +item.planQty;
                        });
                        this.tableData = [].concat(inboundList);
                        this.handleImgList(res.data.images);
                    }
                })
                .catch(() => {});
            await this.$nextTick(() => {
                this.initViewer();
            });
            this.loading = false;
        },
        // 获取网点出库信息
        async outboundList() {
            const params = this.getListParams();
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res) {
                        const data = res.data;
                        this.totalForm = data;
                        const outboundList = data.netTaskItems || [];
                        outboundList.map((item) => {
                            item.netStorageCount = item.netStorageCount || 0;
                        });
                        this.tableData = [].concat(outboundList);
                        this.handleImgList(res.data.images);
                    }
                })
                .catch(() => {});
            await this.$nextTick(() => {
                this.initViewer();
            });
            this.loading = false;
        },
        // 获取用户签收信息2C
        async clientSignList() {
            const params = this.getListParams();
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res) {
                        const data = res.data;
                        this.totalForm = data;
                        const netTaskItemsList = data.netTaskItems || [];
                        netTaskItemsList.forEach((item) => {
                            item.planQty = item.planQty || 0;
                            this.tableData.push({
                                id: item.id,
                                customerItemCode: item.customerItemCode,
                                itemName: item.itemName,
                                planQty: item.planQty,
                                netRealReceive: {
                                    show: true,
                                    value: item.netRealReceive,
                                    showToptip: false
                                },
                                netStockoutCount: { show: true, value: 0 },
                                netRejectQty: { show: true, value: 0 },
                                networkSignRemark: item.networkSignRemark || '',
                                itemLineNo: item.itemLineNo,
                                version: item.version,
                                orderNo: item.orderNo
                            });
                        });
                        // 获取图片
                        this.handleImgList(res.data.images);
                        this.countAppointStatus();
                    }
                })
                .catch(() => {});
            await this.$nextTick(() => {
                this.initViewer();
            });
            this.loading = false;
        },
        // 获取用户拒签信息
        async clientRejectList() {
            const params = this.getListParams();
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res) {
                        res.data.remark = res.data.finalSignRemark || '';
                        if (this.type === '6') {
                            delete res.data.exceptionReason1Code;
                            delete res.data.exceptionReason1Name;
                            delete res.data.exceptionReason2Code;
                            delete res.data.exceptionReason2Name;
                        }
                        const data = res.data;
                        this.totalForm = data;
                        const netTaskItemsList = data.netTaskItems || [];
                        netTaskItemsList.forEach((item) => {
                            item.planQty = item.planQty || 0;
                            this.tableData.push({
                                id: item.id,
                                customerItemCode: item.customerItemCode,
                                itemName: item.itemName,
                                planQty: item.planQty,
                                netRealReceive: item.netRealReceive,
                                networkSignRemark: item.networkSignRemark || '',
                                itemLineNo: item.itemLineNo,
                                version: item.version,
                                orderNo: item.orderNo
                            });
                        });
                        // 获取图片
                        this.handleImgList(res.data.images);
                    }
                })
                .catch(() => {});
            await this.$nextTick(() => {
                this.initViewer();
            });
            this.loading = false;
        },
        // 获取上门取件信息
        async pickupList() {
            const params = this.getListParams();
            await api
                .netTaskItems(params)
                .then((res) => {
                    if (res) {
                        res.data.remark = res.data.pickUpRemark || '';
                        if (this.type === '8') {
                            delete res.data.exceptionReason1Code;
                            delete res.data.exceptionReason1Name;
                            delete res.data.exceptionReason2Code;
                            delete res.data.exceptionReason2Name;
                        }
                        const data = res.data;
                        this.totalForm = data;
                        const netTaskItemsList = data.netTaskItems || [];
                        netTaskItemsList.forEach((item) => {
                            item.planQty = item.planQty || 0;
                            this.tableData.push({
                                id: item.id,
                                customerItemCode: item.customerItemCode,
                                itemName: item.itemName,
                                netRealReceive: item.planQty,
                                version: item.version,
                                orderNo: item.orderNo
                            });
                        });
                        // 获取图片
                        this.handleImgList(res.data.images);
                    }
                })
                .catch(() => {});
            await this.$nextTick(() => {
                this.initViewer();
            });
            this.loading = false;
        },

        // 网点签收确认
        handleNetConfirm() {
            let flag = false;
            this.tableData.find((item) => {
                if (item.netRealReceive.value < 0) {
                    item.netRealReceive.showToptip = true;
                    flag = true;
                    return true;
                }
            });
            if (flag) return false;
            // 判断是否存在短少
            const netStockoutTotalCount = this.netStockoutCounts;
            if (netStockoutTotalCount >= 1) {
                this.$confirm('网点签收存在货物异常，请确认是否正确!', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.handleNetConfirmSure();
                    })
                    .catch(() => {});
            } else {
                this.handleNetConfirmSure();
            }
        },
        handleNetConfirmSure() {
            const netTaskItemData = _.clone(this.tableData);
            netTaskItemData.map((item) => {
                item.netRealReceive = item.netRealReceive.value;
                item.netStockoutCount = item.netStockoutCount.value;
                item.netRejectQty = item.netRejectQty.value;
            });
            const params = {
                netTaskItem: netTaskItemData,
                networkReceiptName: this.totalForm.networkReceiptName,
                netReceiveCount: this.netReceiveCount,
                netAbnormalCount: this.netAbnormalCount
            };
            this.$refs.formInfo.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    await api
                        .networkSign(params)
                        .then((res) => {
                            if (res && +res.code === 0) {
                                this.$message.success('网点签收确认成功');
                                this.closeAndRefresh();
                            }
                        })
                        .catch(() => {});
                    this.loading = false;
                }
            });
        },
        // 网点拒收确认
        branchRejectConfirm() {
            if (this.imgArr.length < 1) return this.$message.warning('请先上传附件');
            let branchRejectRemarkCheck = false;
            this.tableData.find((item) => {
                if (!item.branchRejectRemark) {
                    branchRejectRemarkCheck = true;
                    return true;
                }
            });
            if (branchRejectRemarkCheck) return this.$message.warning('备注都必填');
            const netTasks = {
                id: this.rowData.id,
                orderNo: this.totalForm.orderNo,
                c2mType: 'HWM',
                refuseName: this.totalForm.refuseName,
                branchRejectRemark: this.tableData[0].branchRejectRemark,
                netRealReceive: 0,
                netRejectQty: this.tableData[0].netRejectQty.value,
                version: this.rowData.version
            };
            const params = {
                netTasks: netTasks,
                netReceiveCount: this.netReceiveCount,
                netAbnormalCount: this.netAbnormalCount
            };
            this.$refs.formInfo.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    api.networkRefuseSign(params).then((res) => {
                        if (res && +res.code === 0) {
                            this.$message.success('网点拒收确认成功');
                            this.closeAndRefresh();
                        }
                    }).finally(() => { this.loading = false; });
                }
            });
        },

        // 用户签收确认2B(终端签收)
        handleFinalConfirm() {
            let flag = false;
            this.tableData.find((item) => {
                if (item.finalRealReceive.value < 0) {
                    item.finalRealReceive.showToptip = true;
                    flag = true;
                    return true;
                }
            });
            if (flag) return false;
            const finalItemData = _.clone(this.tableData);
            finalItemData.map((item) => {
                item.finalRealReceive = item.finalRealReceive.value;
                item.finalStockoutCount = item.finalStockoutCount.value;
                item.finalRejectQty = item.finalRejectQty.value;
                item.finalPackageDamaged = item.finalPackageDamaged.value;
                item.finalMildewPollute = item.finalMildewPollute.value;
            });
            const params = {
                netTaskItem: finalItemData,
                finalReceiptName: this.totalForm.finalReceiptName,
                finalReceiveCount: this.finalReceiveCount,
                finalAbnormalCount: this.finalAbnormalCount,
                addedServiceType: this.totalForm.addedServiceType
            };
            this.$refs.formInfo.validate(async (valid) => {
                if (valid) {
                    this.loading = true;
                    await api
                        .finalSign(params)
                        .then((res) => {
                            if (res && +res.code === 0) {
                                this.$message.success('用户签收确认成功');
                                this.closeAndRefresh();
                            }
                        })
                        .catch(() => {});
                    this.loading = false;
                }
            });
        },
        // 网点入库确认
        async handleInboundConfirm() {
            if (this.imgArr.length < 1) return this.$message.warning('请先上传附件');
            this.loading = true;
            const params = {
                orderNo: this.rowData.orderNo,
                netInRemark: this.totalForm.netInRemark
            };
            await api
                .netInfoIn(params)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success('网点入库确认成功');
                        this.closeAndRefresh();
                    }
                })
                .catch(() => {});
            this.loading = false;
        },
        // 网点出库确认
        async handleOutboundConfirm() {
            if (this.imgArr.length < 1) return this.$message.warning('请先上传附件');
            this.loading = true;
            const params = {
                orderNo: this.rowData.orderNo,
                netOutRemark: this.totalForm.netOutRemark
            };
            await api
                .netInfoOut(params)
                .then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success('网点出库确认成功');
                        this.closeAndRefresh();
                    }
                })
                .catch(() => {});
            this.loading = false;
        },
        // 用户签收确认2C
        handleClientSignConfirm2C() {
            let flag = true;
            this.$refs.formInfo.validate((value) => {
                flag = value;
            });
            if (!flag) return;
            const params = {
                orderNo: this.rowData.orderNo,
                signResult: 0,
                addedServiceType: this.totalForm.addedServiceType,
                finalSignRemark: this.totalForm.remark,
                isPc: 1
            };
            api.finalSingn2C(params)
                .then((res) => {
                    if (res) {
                        this.$message.success('确认成功');
                        this.closeAndRefresh();
                    }
                })
                .catch(() => {});
        },
        // 用户拒签确认
        handleClientRejectConfirm() {
            let flag = true;
            this.$refs.formInfo.validate((value) => {
                flag = value;
            });
            if (!flag) return;
            const params = {
                orderNo: this.rowData.orderNo,
                exceptionReason1Code: this.totalForm.exceptionReason1Code,
                exceptionReason1Name: this.totalForm.exceptionReason1Name,
                exceptionReason2Code: this.totalForm.exceptionReason2Code,
                exceptionReason2Name: this.totalForm.exceptionReason2Name,
                finalSignRemark: this.totalForm.remark,
                signResult: 1
            };
            api.finalSingn2C(params)
                .then((res) => {
                    if (res) {
                        this.$message.success('拒签成功');
                        this.closeAndRefresh();
                    }
                })
                .catch(() => {});
        },
        // 拒签审核驳回 取件失败驳回
        handleReject() {
            const params = {
                orderNo: this.rowData.orderNo
            };
            api.dismissRejuct(params)
                .then((res) => {
                    if (res) {
                        this.$message.success('驳回成功');
                        this.closeAndRefresh();
                    }
                })
                .catch(() => {});
        },
        // 拒签审核通过 取件失败通过
        handleApprove() {
            const params = {
                orderNo: this.rowData.orderNo
            };
            api.approveRejuct(params)
                .then((res) => {
                    if (res) {
                        this.$message.success('审核成功');
                        this.closeAndRefresh();
                    }
                })
                .catch(() => {});
        },
        // 取件成功
        hadlePickupSuccess() {
            const params = {
                orderNo: this.rowData.orderNo,
                pickUpRemark: this.totalForm.remark
            };
            api.pickupSuccess(params)
                .then((res) => {
                    if (res) {
                        this.$message.success('提交成功');
                        this.closeAndRefresh();
                    }
                })
                .catch(() => {});
        },
        // 取件失败
        hadlePickupFail() {
            if (!this.totalForm.exceptionReason2Code) {
                return this.$message.warning('请先选择取件失败原因');
            }
            const params = {
                orderNo: this.rowData.orderNo,
                pickUpRemark: this.totalForm.remark,
                exceptionReason1Code: '18',
                exceptionReason1Name: '揽收失败',
                exceptionReason2Code: this.totalForm.exceptionReason2Code,
                exceptionReason2Name: this.totalForm.exceptionReason2Name
            };
            api.pickupFail(params)
                .then((res) => {
                    if (res) {
                        this.$message.success('提交成功');
                        this.closeAndRefresh();
                    }
                })
                .catch(() => {});
        },
        getRefuseReason1(value) {
            this.currentReason2List = this.REFUSE_REASON_2[value];
            this.$set(this.totalForm, 'exceptionReason1Name', value);
            this.$set(this.totalForm, 'exceptionReason2Code', '');
            this.$set(this.totalForm, 'exceptionReason2Name', '');
        },
        getRefuseReason2(value) {
            this.currentReason2List.forEach(item => {
                if (item.value === value) {
                    this.$set(this.totalForm, 'exceptionReason2Name', item.label);
                }
            });
        },
        closeDialogOnly() {
            this.$emit('closeDialog', 'branchSignNewDialog', false);
        },
        closeAndRefresh() {
            this.$emit('closeDialog', 'branchSignNewDialog', true);
        }
    },
    computed: {
        ...mapState({ user: (state) => state.user }),
        // 网点签收正品(单行)
        netRealReceive(index) {
            return (index) => {
                // 正品=订单数量(单行)-短少-拒收
                const item = this.tableData[index];
                item.netStockoutCount.value = item.netStockoutCount.value || 0;
                item.netRejectQty.value = item.netRejectQty.value || 0;
                item.netRealReceive.value =
                    item.planQty -
                    item.netStockoutCount.value -
                    item.netRejectQty.value;
                return item.netRealReceive.value;
            };
        },
        // 终端签收正品(单行)
        finalRealReceive(index) {
            return (index) => {
                // 正品=网点签收正品数量(单行)-（短少-拒收-污染-破损）(终端)
                const item = this.tableData[index];
                item.finalStockoutCount.value = item.finalStockoutCount.value || 0;
                item.finalRejectQty.value = item.finalStockoutCount.value || 0;
                item.finalMildewPollute.value = item.finalStockoutCount.value || 0;
                item.finalPackageDamaged.value = item.finalStockoutCount.value || 0;
                item.netRealReceive = item.finalStockoutCount.value || 0;
                item.finalRealReceive.value =
                    item.netRealReceive -
                    item.finalStockoutCount.value -
                    item.finalRejectQty.value -
                    item.finalMildewPollute.value -
                    item.finalPackageDamaged.value;
                return item.finalRealReceive.value;
            };
        },
        // 网点签收实收(汇总)
        netReceiveCount() {
            let total = 0;
            this.tableData.forEach((item) => {
                // 实收数量=正品
                let lineTotal = 0;
                lineTotal += Number(item.netRealReceive.value);
                item.netReceiveCount = lineTotal; // 单行实收
                total += lineTotal;
            });
            return total;
        },
        // 网点签收异常(汇总)
        netAbnormalCount() {
            let total = 0;
            this.tableData.forEach((item) => {
                // 异常=拒收+短少
                let lineTotal = 0;
                lineTotal += Number(item.netRejectQty.value);
                lineTotal += Number(item.netStockoutCount.value);
                item.netAbnormalCount = lineTotal; // 单行异常
                total += lineTotal;
            });
            return total;
        },
        // 终端签收实收(汇总)
        finalReceiveCount() {
            let total = 0;
            this.tableData.forEach((item) => {
                // 实收数量=正品+污染+破损
                let lineTotal = 0;
                lineTotal += Number(item.finalRealReceive.value);
                lineTotal += Number(item.finalMildewPollute.value);
                lineTotal += Number(item.finalPackageDamaged.value);
                item.finalReceiveCount = lineTotal; // 单行实收
                total += lineTotal;
            });
            return total;
        },
        // 终端签收异常(汇总)
        finalAbnormalCount() {
            let total = 0;
            this.tableData.forEach((item) => {
                // 异常=拒收+短少+污染+破损
                let lineTotal = 0;
                lineTotal += Number(item.finalRejectQty.value);
                lineTotal += Number(item.finalStockoutCount.value);
                lineTotal += Number(item.finalMildewPollute.value);
                lineTotal += Number(item.finalPackageDamaged.value);
                item.finalAbnormalCount = lineTotal; // 单行异常
                total += lineTotal;
            });
            return total;
        },
        // 网点签收短少汇总
        netStockoutCounts() {
            let netStockoutTotalCount = 0;
            this.tableData.forEach((item) => {
                netStockoutTotalCount += Number(item.netStockoutCount.value);
            });
            return netStockoutTotalCount;
        }
    }
};
</script>
<style lang="less">
@import './branchSign.less';
</style>
